import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import NavBar from '../components/Menu/NavBar'
import { pageStyle } from '../components/UIComponent/CommonStyle'
import OTHistory from '../components/CompLeaveReqsApproval/OTHistory';
import { setLocalStorageSettings } from '../components/Function/globalFunction';

const useStyles = makeStyles(() => ({
    ...pageStyle()
}));

export default function OTHistoryPage({ routing, routingId }) {
    const classes = useStyles();
    setLocalStorageSettings({
        'selectedIndex': 8,
        'isMyRequestOpen': 'false',
        'isApplicationOpen': 'false',
        'isLeaveApprovalOpen': 'false',
        'isHRAdminOpen': 'true'
    });

    return (
        <div className={classes.root}>
            <CssBaseline />
            <NavBar />
            <OTHistory />
        </div>
    )
}